import { createContext, useContext, useEffect, useState, ReactNode } from 'react';

const BackendContext = createContext<string|number>('');

export const useBackend = () => useContext(BackendContext);

function BackendProvider({ children }: { children: ReactNode }) {
  const [backend, setBackend] = useState('');

  useEffect(() => {
    const url = '/webclient/php/get_backend.php';
    fetch(url)
      .then((res) => {
        if (!res.ok) {
          throw new Error('Anfrage fehlgeschlagen');
        }
        return res.json();
      })
      .then((data) => {
        setBackend(data);
      })
      .catch((err) => {
        console.log(err.message);
      });
  }, []);

  return (
    <BackendContext.Provider value={backend}>
      {children}
    </BackendContext.Provider>
  );
}

export default BackendProvider;
